import {getImage} from '@dazn/lp-web/src/utils/commonUtils';
import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';
import {buttonProxy} from '@dazn/lp-web/src/proxies/button.proxy';

export function comingUpProxy(component: any): any {
    const componentType = component?.fields?.componentType;
    const title = component?.fields?.title;
    const theme = component?.fields?.theme;
    const tiles = component?.fields?.entries?.map((entry: any) => {
        const {title, badgeText, showBadge, backgroundImage, buttons} =
            entry?.fields ?? {};

        return {
            title,
            badgeText,
            showBadge,
            image: getImage(backgroundImage),
            button: buttonProxy(buttons?.[0]?.fields)
        };
    });

    return {
        title,
        componentType,
        tiles,
        railType: ComponentTypes.COMING_UP_RAIL,
        theme: theme || 'default'
    };
}
